import './App.css';
import React from 'react';
import Colors from "./color"

function App() {
  return (
    <div>
      <h1 style={{textAlign:'center',color:'#837494'}}>Kartik's UI Color Picker Tools</h1>
      <h1 style={{textAlign:'center'}}>Click to Copy</h1>
   <Colors/>
    </div>
  );
}

export default App;
